<i *ngIf="iconClass" class="icon icon--24 anc-toast__icon" [ngClass]="iconClass" aria-hidden="true"></i>
<div class="anc-toast__content">
    <p *ngIf="title" class="anc-toast__overline">{{ title }}</p>
    <div *ngIf="message" class="anc-toast__message" role="alert" [attr.aria-label]="message">{{ message }}</div>
</div>
<button *ngIf="options.closeButton" type="button" class="anc-toast__close" (click)="remove()" aria-label="Close">
    <i class="icon icon--24 icon-close" aria-hidden="true"></i>
</button>
